<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    import type { DatabricksConditionInputDefinition } from 'header/types';

    interface Props {
        field: DatabricksConditionInputDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    let column = $derived(field.value.field);
    let order = $derived(field.value.order);
    let limit = $derived(field.value.limit);

    const updateColumn = (e: { currentTarget: HTMLSelectElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: {
                    ...field.value,
                    field: e.currentTarget.value,
                },
            },
        });
    };

    const updateOrder = (e: { currentTarget: HTMLSelectElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: {
                    ...field.value,
                    order: e.currentTarget.value,
                },
            },
        });
    };

    const updateLimit = (e: { currentTarget: HTMLInputElement }) => {
        const parsedValue = Number.parseInt(e.currentTarget.value, 10);
        const MIN_LIMIT_VALUE = 1;
        const value =
            parsedValue > field.conditionMaxLimit
                ? field.conditionMaxLimit
                : parsedValue < MIN_LIMIT_VALUE
                  ? MIN_LIMIT_VALUE
                  : parsedValue;

        dispatch('change', {
            field: {
                ...field,
                value: {
                    ...field.value,
                    limit: value,
                },
            },
        });
        e.currentTarget.value = value.toString();
    };
</script>

<div class="row">
    <span class="row-name">Field: </span>
    <div class="labels">
        <div class="label">
            <select value={column} onchange={updateColumn}>
                {#each field.condtitionFieldOptions as opt}
                    <option>{opt.key}</option>
                {/each}
            </select>
        </div>
    </div>
</div>
<div class="row">
    <span class="row-name">Order: </span>
    <div class="labels">
        <div class="label">
            <select
                value={order}
                disabled={!field.conditionAllowChangeOrder}
                onchange={updateOrder}
            >
                <option>ASC</option>
                <option>DESC</option>
            </select>
        </div>
    </div>
</div>
<div class="row">
    <span class="row-name">Limit: </span>
    <div class="labels">
        <div class="label">
            <input type="number" value={limit} onchange={updateLimit} />
        </div>
    </div>
</div>

<style lang="scss" scoped>
    .row {
        font-size: 0.7rem;

        .labels {
            padding: 1px;
            min-height: 24px;
        }
    }
</style>
